import { useState } from 'react';
import { useNavigate } from 'react-router';
import Header from '../../components/Header';
import HeroSection from '../../components/landing/HeroSection';
import WhyItMatters from '../../components/landing/WhyItMatters';
import HowAndDifferenceSection from '../../components/landing/HowAndDifferenceSection';
import PricingCtaSection from '../../components/landing/PricingCtaSection';
import ReferralBanner from '../../components/landing/ReferralBanner';
import Footer from '../../components/landing/Footer';
import InvestigationFlow from '../../components/modals/InvestigationFlow';

// Google Calendar appointment scheduler — "Book a meeting" / "Contact our Associate" both go here.
const CALENDAR_URL =
    'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1X55XupDolgAEHQOxuiyB8bdyB9hO53uywaJpR60NtMsnMHgAoDlVXD-jzYrNA2z-0z0NIbXvf?gv=true';

const WaitList = () => {
    const navigate = useNavigate();

    const [isFlowOpen, setIsFlowOpen] = useState(false);

    const goToSignup = () => navigate('/signup');

    // Proceed starts the real checkout here rather than bouncing to signup: a
    // visitor picks their plan and enters who they are checking first, and is
    // only asked to create an account at the point of payment, by which time
    // their work is already parked and waiting for them.
    const startInvestigation = () => setIsFlowOpen(true);
    const openScheduler = () => window.open(CALENDAR_URL, '_blank', 'noopener,noreferrer');

    return (
        <div className="min-h-screen bg-[#FFFFFF] flex flex-col">
            <Header />
            <main className="flex-1">
                <HeroSection />
                <WhyItMatters />
                <HowAndDifferenceSection />
                <PricingCtaSection onProceed={startInvestigation} onContactAssociate={openScheduler} />
                <ReferralBanner onBecomePartner={goToSignup} />
            </main>
            <Footer onBookMeeting={openScheduler} />

            <InvestigationFlow isOpen={isFlowOpen} onClose={() => setIsFlowOpen(false)} />
        </div>
    );
};

export default WaitList;
